export const learningUsers = [
  {
    User: "Test@lexarhomes.com",
    mail: "Test@lexarhomes.com",
    Approval: true,
    Plans: true,
    Pricing: true,
    Lenders: true,
    Draws: true,
    OfficeSettings: false,
    UID: 1,
    Office365ID: null,
    PM: true,
    MainFID: 4,
    SchemeID: 20,
    DraftAssignment: false,
    ShowPrice: true,
    IsDrafter: false,
    FirstName: "Lexar",
    LastName: "User",
    defaultFID: 1,
    isDev: undefined,
    isSales: true,
    DraftAccess: false,
    ApprovalAccess: true,
    PriceCheckAccess: true,
    DisplayName: "Lexar User",
    displayName: "Lexar User",
    BinderPriceChange: true,
    StandardChange: true,
    StandardsCheck: null,
    ApprovalNotify: false,
    Dark: false,
    ES_Key: null,
    ES_BID: null,
    PCNotify: false,
    ESNotify: null,
    DraftNotify: false,
    EditBinderPlan: true,
    Beta: false,
    ApprovedNotify: false,
    Address1: "",
    Address2: "",
    Title: "",
    EmailSignature: "",
    Role: "Consultant",
    isAdmin: false,
    ThemeID: 2,
    rProcess: undefined,
    yProcess: undefined,
    gProcess: undefined,
    TrainingAdmin: undefined,
    TaxOverride: false,
    EmailBriefing: undefined,
    isOp: true,
    Archived: false,
    PartTime: undefined,
    Manager: undefined,
    ShowTravel: false,
    StandardIncluded: true,
    PrintFormat: "Letter",
    UI_MenuExpanded: false,
    UI_CatMenuExpanded: false,
    UI_OtherExpanded: true,
    UI_Padding: 10,
    UI_BorderRadius: 10,
    UI_HeaderSize: 50,
    UI_FieldSize: 40,
    UI_UISize: 40,
    UI_SubfieldSize: 25,
    UIStyleID: 3,
    isCaseManager: false,
    DefaultDraftScreen: "Time",
    AzureID: "",
    modifiedDate: new Date("2023-09-14T21:54:55.526Z"),
    createdDate: undefined,
    defaultDash: undefined,
    menuMode: undefined,
    colorScheme: undefined,
    theme: undefined,
    scale: undefined,
    setup: true
  }
];

